export const domains = [
  {
    domain: '880dundas1504.com',
    tourId: 'DXEqUkccv'
  },
  {
    domain: '274foresthillrd.com',
    tourId: 'kfFKRZWmg'
  },
  {
    domain: '80johnst1906.com',
    tourId: 'EBInizStJ'
  },
  {
    domain: '15277yonge.com',
    tourId: 'pg1wQIVS4'
  },
  {
    domain: '11mcnally.com',
    tourId: '11-mcnally-st-georgetown-on-l7g-6b7'
  },
  {
    domain: '821coxfordst.com',
    tourId: 'pPbH_cxhO'
  },
  {
    domain: '20minowanmiikan731.com',
    tourId: '731-20-minowan-miikan-ln-toronto-on-m6j-1m3'
  },
  {
    domain: '105thequeensway.com',
    tourId: 'p2p-niqUH'
  },
  {
    domain: '267glebemount.com',
    tourId: '267-glebemount-ave-east-york-on-m4c-3t7'
  },
  {
    domain: '24brooklynave.com',
    tourId: '24-brooklyn-ave-toronto-on-m4m-2x5'
  },
  {
    domain: 'copernicussoftware.com',
    tourId: 'Demo1-City-State-ZipCode'
  }
];

export const getCustomDomainTourId = () => {
  const domain = domains.find(({domain}) => domain === window.location.hostname)

  return domain ? domain.tourId : undefined
}
